
<template>
  <v-container fluid>
    <negotiation-list/>
  </v-container>
</template>

<script>

export default {
  name: 'Negotiations',
  components: {
    NegotiationList: () => import ('@/components/negotiations/NegotiationList.vue')
  },
}
</script>

<style scoped>

</style>